const DeletedPage = () => 'Page supprimée.';

export const HomePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/HomePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const AdminHomePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/accueil/AdminHomePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const LogsListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-logs/LogsListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const UsersListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-utilisateurs/UsersListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewUserPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-utilisateurs/nouvel-utilisateur/NewUserPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const UserPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/admin/liste-des-utilisateurs/[user_id]/UserPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const SubfamilyPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/articles/[article_subfamily]/SubfamilyPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const DemandeOuverturePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/demande-ouverture-compte/DemandeOuverturePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const BerokiPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/entite/BEROKI/BerokiPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const C2ClimPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/entite/C2Clim/C2ClimPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const LTFPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/entite/LTF/LTFPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const EspaceProPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/espace-pro/EspaceProPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const GestionHomePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/accueil/GestionHomePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ArticlesListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-articles/ArticlesListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const DeleteArticlesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-articles/delete-articles/DeleteArticlesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ImportArticlesPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-articles/import-articles/ImportArticlesPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ImportTarifsGPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-articles/import-tarifs/ImportTarifsGPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const AdSectionsListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-bannieres-pub/AdSectionsListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewAdSectionPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-bannieres-pub/nouvelle-section/NewAdSectionPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const EditAdSectionPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-bannieres-pub/[id]/EditAdSectionPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ClientsListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-clients/ClientsListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ImportClientsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-clients/import-clients/ImportClientsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ImportContactsPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-clients/import-contacts/ImportContactsPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ClientPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-clients/[client_id]/ClientPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CommandesListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-commandes/CommandesListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CommandePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-commandes/[commande_n]/CommandePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const DemandesListPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-demandes/DemandesListPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const DemandePage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-demandes/[demande_id]/DemandePage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const TarifsPPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-tarifs-particuliers/TarifsPPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const DeleteTarifsPPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-tarifs-particuliers/delete-tarifs/DeleteTarifsPPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ImportTarifsPPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/liste-des-tarifs-particuliers/import-tarifs/ImportTarifsPPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const BrandsLogosEditPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/gestion/logos-marques/BrandsLogosEditPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CGUPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/infos-legales/cgu/CGUPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CGVPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/infos-legales/cgv/CGVPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const PDCPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/infos-legales/pdc/PDCPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const PUCPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/infos-legales/puc/PUCPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const MyAccountPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mon-compte/MyAccountPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const MyOrdersPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mon-compte/commandes-et-devis/MyOrdersPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const OrderDetailPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mon-compte/commandes-et-devis/[text_number]/OrderDetailPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const RequestPasswordPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mot-de-passe-oublie/RequestPasswordPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const NewPasswordPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/mot-de-passe-oublie/nouveau-mot-de-passe/[token]/NewPasswordPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const CartPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/panier/CartPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const ArticleNotFoundPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/recherche/article-non-trouve/ArticleNotFoundPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

export const SearchResultPage = async function ()
{
	try
	{
		var { default: Component } = await import('./pages/recherche/[searched]/SearchResultPage');
	}
	catch (e)
	{
		Component = DeletedPage;
	}
	return { Component };
};

const ROUTES = { HomePage, AdminHomePage, LogsListPage, UsersListPage, NewUserPage, UserPage, SubfamilyPage, DemandeOuverturePage, BerokiPage, C2ClimPage, LTFPage, EspaceProPage, GestionHomePage, ArticlesListPage, DeleteArticlesPage, ImportArticlesPage, ImportTarifsGPage, AdSectionsListPage, NewAdSectionPage, EditAdSectionPage, ClientsListPage, ImportClientsPage, ImportContactsPage, ClientPage, CommandesListPage, CommandePage, DemandesListPage, DemandePage, TarifsPPage, DeleteTarifsPPage, ImportTarifsPPage, BrandsLogosEditPage, CGUPage, CGVPage, PDCPage, PUCPage, MyAccountPage, MyOrdersPage, OrderDetailPage, RequestPasswordPage, NewPasswordPage, CartPage, ArticleNotFoundPage, SearchResultPage };
export default ROUTES;